import { useEffect, useLayoutEffect, useRef, useState } from "react";
import db from "./Firebase";
import {
  collection,
  getDocs,
  query,
  doc,
  setDoc,
  getDoc,
} from "firebase/firestore";

import { getDocsx, getDocx, docx, setDocx, collectionx, queryx } from "./SubtaskNewServer"

import payrate from "./payrate";
import "./Edit.css";
import Button from "react-bootstrap/Button";
import moment from "moment";
import _ from "lodash";

import { IoAdd } from "react-icons/io5";
import { AiFillDelete, AiFillCheckCircle, AiFillSave, AiFillStar } from "react-icons/ai"
import { BiReset } from "react-icons/bi"
import { FaArrowDown, FaArrowUp, FaPlus, FaSync, FaClock, FaTag, FaCoins, FaCalendarAlt, FaCalendarCheck, FaExclamationTriangle } from "react-icons/fa";
import useWindowDimensions from "./useWindowDimensions";

import Form from "react-bootstrap/Form";
import { MdDelete, MdSave, MdClose, MdCalendarToday } from "react-icons/md";
import { FaAngleRight, FaChevronDown } from "react-icons/fa";

import { Col, Container, Row, Spinner, Alert, Dropdown, Badge } from "react-bootstrap";
import { syncBalance } from "./balanceUtils";
import { mqttUpdate } from "./mqttUtils";
import { parseSubsubDate, getSubsubValidityStatus } from "./subsubValidity";

const TIME_SLOTS = [0, 1, 2, 3, 4, 5];
const SUBSUB_TIME_OPTIONS = [0, 1, 2, 3, 4];
const SUBSUB_TIME_UNIT_SCALE = 2;

const RECALL_OPTIONS = [
  { label: "In 1 day", value: 1 },
  { label: "In 2 days", value: 2 },
  { label: "In 3 days", value: 3 },
  { label: "In 1 week", value: 7 },
  { label: "In 10 days", value: 10 },
  { label: "In 2 weeks", value: 14 },
];

const getTimeButtonVariant = (currentValue, option) => {
  if (currentValue == option) {
    return option === 0 ? "danger" : "primary";
  }
  return "outline-primary";
};

const getCountdownColor = (dateStr) => {
  if (!dateStr) return '#888';
  try {
    const target = parseSubsubDate(dateStr);
    if (!target) return '#888';
    const diffDays = target.diff(moment(), 'hours', true) / 24;
    if (diffDays <= 0) return '#ff2d44';
    if (diffDays < 1) return '#fd7e14';
    if (diffDays < 3) return '#ffc107';
    return '#4dabff';
  } catch (e) {
    return '#888';
  }
};

const getCountdownLabel = (dateStr) => {
  if (!dateStr) return null;
  try {
    const target = parseSubsubDate(dateStr);
    if (!target || !target.isValid()) return null;
    const diffMs = target.diff(moment());
    const absDiff = Math.abs(diffMs);
    const totalHours = Math.floor(absDiff / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    return `${days}d ${hours}h`;
  } catch (e) {
    return null;
  }
};

function Edit() {

  const [stamp, setStamp] = useState([]);
  const [dailySn, setDailySn] = useState("");
  const [data, setData] = useState({});
  const [totalTime, setTotalTime] = useState(0);
  const [totalTimeReward, setTotalTimeReward] = useState(0);
  const [optUpdateFlag, setOptUpdateFlag] = useState(0);
  const [doneList, setDoneList] = useState([]);
  const [subsubHistoryToSync, setSubsubHistoryToSync] = useState([]); // to help sync the subsubHistory, we need another list to store only the newly added subsubHistory
  const [doneListForSubs, setDoneListForSubs] = useState([]);
  const [enableDelete, setEnableDelete] = useState(true);
  const { height, width } = useWindowDimensions();
  const BODY_MAX_WIDTH = 960;
  const CART_PANEL_WIDTH = 280;
  const CART_PANEL_OFFSET = 10;
  const CART_PANEL_GUTTER = 24;
  const safeWindowWidth = width || 0;
  const currentBodyWidth = Math.min(safeWindowWidth, BODY_MAX_WIDTH);
  const availableLeftMargin = Math.max(
    (safeWindowWidth - currentBodyWidth) / 2,
    0
  );
  const requiredLeftMargin =
    CART_PANEL_OFFSET + CART_PANEL_WIDTH + CART_PANEL_GUTTER;
  const canShowCartSummary = availableLeftMargin >= requiredLeftMargin;
  const actionBarRef = useRef(null);
  const editPageRef = useRef(null);

  useLayoutEffect(() => {
    if (!actionBarRef.current || !editPageRef.current) return;

    const update = () => {
      const rect = actionBarRef.current.getBoundingClientRect();
      if (rect?.height) {
        editPageRef.current.style.setProperty("--action-bar-height", `${rect.height}px`);
      }
    };

    update();

    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(update);
      ro.observe(actionBarRef.current);
    }
    window.addEventListener("resize", update);

    return () => {
      window.removeEventListener("resize", update);
      if (ro) ro.disconnect();
    };
  }, []);

  // const [dailyTemplates, setDailyTemplates] = useState([
  //   {
  //     name: 'Test1',
  //     subs: [
  //       { sname: 'Reinf Lrn', time: 1, finish: 0.68 },
  //       {
  //         sname: 'mcts',
  //         time: 1,
  //         finish: 0.68,
  //       },
  //     ],
  //   },
  //   {
  //     name: 'Test2',
  //     subs: [],
  //   },
  // ])
  const [dailyTemplates, setDailyTemplates] = useState([])
  const [selectedDailyTemplate, setSelectedDailyTemplate] = useState('')
  const [nameDailyTemplate, setNameDailyTemplate] = useState('')
  const [templateExpanded, setTemplateExpanded] = useState(false)
  // const payrate = 0.5

  const [viewOption, setViewOption] = useState("notpostponed")

  const [savingStamp, setSavingStamp] = useState(false)
  const [stampId, setStampId] = useState("")
  const [showOnlySelected, setShowOnlySelected] = useState(false)
  const [expandedTaskDetails, setExpandedTaskDetails] = useState(new Set())
  const [expandedSubSubDetails, setExpandedSubSubDetails] = useState(new Set())
  const [activeSubsubTimeInput, setActiveSubsubTimeInput] = useState(null)
  const [filterTag, setFilterTag] = useState(null);

  const toSubsubTimeDisplay = (value) => {
    if (value === "" || value === null || value === undefined) {
      return value;
    }
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return value;
    }
    return numeric * SUBSUB_TIME_UNIT_SCALE;
  };

  const toSubsubTimeStorage = (value) => {
    if (value === "" || value === null || value === undefined) {
      return 0;
    }
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return 0;
    }
    return numeric / SUBSUB_TIME_UNIT_SCALE;
  };

  const loadStamp = async () => {
    setSavingStamp(true)
    let subs = [];
    // Load the tasks
    const querySnapshot = await getDocsx(queryx(collectionx(db, "subtasks")));
    console.log("querySnapshot", querySnapshot)
    if (querySnapshot.size == 0) {
      return;
    }
    querySnapshot.forEach((doc) => {
      if (doc.id.indexOf("DAILY") > -1) {
        let data = doc.data();
        setData(Object.assign({}, data));
        setDailySn(doc.id);
        setStampId(data.id)

        console.log("data", data)
        console.log("data.id", data.id)
        console.log("doc.id", doc.id)

        // Change the format of the validFromDate and expiryDate
        data.subs.forEach((sub) => {
          if (sub.hasOwnProperty("validFromDate")) {
            if (sub.validFromDate != null && sub.validFromDate != undefined && sub.validFromDate != "") {
              sub.validFromDate = moment(sub.validFromDate.toDate()).format(
                "DD/MM/YYYY HH:mm:ss"
              );
            }
          }
          if (sub.hasOwnProperty("expiryDate")) {
            if (sub.expiryDate != null && sub.expiryDate != undefined && sub.expiryDate != "") {
              sub.expiryDate = moment(sub.expiryDate.toDate()).format(
                "DD/MM/YYYY HH:mm:ss"
              );
            }
          }
          if (sub.hasOwnProperty('allowFeedback')) {
            sub.allowFeedback = String(sub.allowFeedback)
          }

          if (sub.hasOwnProperty('subsubs')) {
            sub.subsubs.forEach((subsub) => {
              if (subsub.time === undefined || subsub.time === null) {
                subsub.time = toSubsubTimeDisplay(subsub.finish)
              } else {
                subsub.time = toSubsubTimeDisplay(subsub.time)
              }
              if (subsub.hasOwnProperty('validFrom')) {
                subsub.validFrom = moment(subsub.validFrom).format(
                  "DD/MM/YYYY HH:mm:ss"
                );
              }
              const parsedExpiryDate = parseSubsubDate(subsub.expiryDate || subsub.validUntil);
              if (parsedExpiryDate) {
                subsub.expiryDate = parsedExpiryDate.format(
                  "DD/MM/YYYY HH:mm:ss"
                );
                if (subsub.hasOwnProperty('validUntil')) {
                  delete subsub.validUntil;
                }
              }
            })
          }
        });

        subs = data.subs;
        setStamp(subs);
      }

      if (doc.id.indexOf("DAILY") > -1) {
        // This is a daily task, we extract its serial number!

        // subs.forEach((sub) => {
        //     if (sub.hasOwnProperty("finish"))
        //     {
        //         sub.finish = sub.finish / payrate * 0.5
        //         // finish should be in "standard time unit, which is 25 minutes"
        //         // the pay is given in this standard time unit. The timer we choose (e.g., 30 minutes)
        //         // should be independent
        //     }
        // })
      }

    });
    // subs.forEach((sub) => {
    //     sub.initialFinish = sub.finish
    // })





    const reportSnapshot = await getDocsx(queryx(collectionx(db, "reports")));
    if (reportSnapshot.size > 0) {
      setEnableDelete(false);
      console.log("report is not empty, disable deleting task")
    }

    // Load doneList collection 
    const doneListQuerySnapshot = await getDocsx(queryx(collectionx(db, "doneList")));
    if (doneListQuerySnapshot.size > 0) {
      doneListQuerySnapshot.forEach((doc) => {
        if (doc.id == "default") {
          let data = doc.data();
          // console.log(data)
          if (data.hasOwnProperty("doneList")) {
            // doneList is not empty set doneList (so that they can be appended, not overwritten)
            setDoneList(data.doneList);
            console.log("doneList set");
          }
        }
      });
    }

    // Load doneListForSubs collection
    const doneListForSubsQuerySnapshot = await getDocsx(queryx(collectionx(db, "doneListForSubs")));
    if (doneListForSubsQuerySnapshot.size > 0) {
      doneListForSubsQuerySnapshot.forEach((doc) => {
        if (doc.id == "default") {
          let data = doc.data();
          // console.log(data)
          if (data.hasOwnProperty("doneListForSubs")) {
            // doneList is not empty set doneList (so that they can be appended, not overwritten)
            setDoneListForSubs(data.doneListForSubs);
            console.log("doneListForSubs set");
          }
        }
      });
    }

    // console.log(subs);
    setSavingStamp(false)
  };

  useEffect(() => {

    // Set document title
    document.title = "Edit Tasks"

    // If locked redirect to home
    if (localStorage.getItem('locked') == 'true') {
      window.location.href = '/'
    }

    loadStamp();
    loadTemplates();
  }, []);

  const isNumeric = (str) => {
    if (typeof str != "string") return false; // we only process strings!
    return (
      !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ); // ...and ensure strings of whitespace fail
  };

  const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  const applySubTimeUpdate = (sub, value) => {
    sub.time = value;
    sub.finish = roundToSecondDecimal(value * payrate);
    sub.initialFinish = value * payrate;
  };

  const zeroOutSubsubTimes = (sub) => {
    if (!sub?.subsubs?.length) {
      return;
    }
    sub.subsubs.forEach((subsub) => {
      subsub.time = 0;
    });
  };

  const getSubsubTimeSum = (sub) => {
    if (!sub?.subsubs?.length) {
      return null;
    }
    let sum = 0;
    let hasValue = false;
    sub.subsubs.forEach((ss) => {
      if (isNumber(ss.time)) {
        sum += Number(ss.time);
        hasValue = true;
      }
    });
    return hasValue ? sum : null;
  }

  const shouldShowSubsubTimeWarning = (sub, subsubTimeSum) => {
    if (sub.hasOwnProperty("countUp") && sub.countUp == 1) {
      return false;
    }
    if (!isNumber(sub.time)) {
      return false;
    }
    if (!isNumber(subsubTimeSum)) {
      return false;
    }
    return Math.abs(Number(subsubTimeSum) - Number(sub.time)) > 0.01;
  }

  const make_serial = (length, terms) => {
    var result = [];
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var charactersLength = characters.length;
    for (let term = 0; term < terms; term++) {
      for (var i = 0; i < length; i++) {
        result.push(
          characters.charAt(Math.floor(Math.random() * charactersLength))
        );
      }
      if (term != terms - 1) result.push("-");
    }
    return result.join("");
  };

  const handleTextChange = (e, fieldname, sn) => {
    if (fieldname == "sname") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["sname"] = e.target.value;
      setStamp(newStamp);
    }
    if (fieldname == "pay") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["finish"] = e.target.value;
      if (isNumeric(e.target.value)) {
        // newStamp[indexOfSub]["finish"] = Number(e.target.value);
        newStamp[indexOfSub]["initialFinish"] = Number(e.target.value);
      }
      setStamp(newStamp);
    }
    if (fieldname == "time") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["time"] = e.target.value;
      if (isNumeric(e.target.value)) {
        const nextTime = Number(e.target.value);
        applySubTimeUpdate(newStamp[indexOfSub], nextTime);
        if (nextTime === 0) {
          zeroOutSubsubTimes(newStamp[indexOfSub]);
        }
      }
      setStamp(newStamp);
    }
    if (fieldname == "bonusCoeff") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["bonusCoeff"] = e.target.value;
      /* if (isNumeric(e.target.value)) {
        newStamp[indexOfSub]["bonusCoeff"] = Number(e.target.value);
      } else {
        newStamp[indexOfSub]["bonusCoeff"] = e.target.value;
      } */
      setStamp(newStamp);
    }
    if (fieldname == "originalTime") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["originalTime"] = e.target.value;
      if (isNumeric(e.target.value)) {
        // newStamp[indexOfSub]["originalTime"] = Number(e.target.value);
        newStamp[indexOfSub]["originalFinish"] =
          Number(e.target.value) * payrate;
        newStamp[indexOfSub]["time"] = Number(e.target.value);
        newStamp[indexOfSub]["finish"] = roundToSecondDecimal(Number(e.target.value) * payrate);
        newStamp[indexOfSub]["initialFinish"] =
          Number(e.target.value) * payrate;
      }
      setStamp(newStamp);
    }
    if (fieldname == "originalFinish") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["originalFinish"] = e.target.value;
      if (isNumeric(e.target.value)) {
        newStamp[indexOfSub]["finish"] = Number(e.target.value);
        newStamp[indexOfSub]["initialFinish"] = Number(e.target.value);
      }
      setStamp(newStamp);
    }
    if (fieldname == "tags") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["tags"] = e.target.value;
      setStamp(newStamp);
    }
    if (fieldname == "allowFeedback") {
      let indexOfSub = stamp.findIndex((x) => x.sn == sn);
      let newStamp = Object.assign([], stamp);
      newStamp[indexOfSub]["allowFeedback"] = e.target.value;
      setStamp(newStamp);
    }
    // update optUpdateFlag
    setOptUpdateFlag(optUpdateFlag + 1);
  };

  const setTimeByButton = (sn, value) => {
    let indexOfSub = stamp.findIndex((x) => x.sn == sn);
    let newStamp = _.cloneDeep(stamp);
    applySubTimeUpdate(newStamp[indexOfSub], value);
    if (value === 0) {
      zeroOutSubsubTimes(newStamp[indexOfSub]);
    } else if (newStamp[indexOfSub]?.subsubs?.length) {
      const positiveSubsubs = newStamp[indexOfSub].subsubs.filter(
        (subsub) => isNumber(subsub.time) && Number(subsub.time) > 0
      );
      if (positiveSubsubs.length === 1) {
        const otherSubsubsEmpty = newStamp[indexOfSub].subsubs.every((subsub) => {
          if (subsub === positiveSubsubs[0]) {
            return true;
          }
          if (!isNumber(subsub.time)) {
            return true;
          }
          return Number(subsub.time) <= 0;
        });
        if (otherSubsubsEmpty) {
          positiveSubsubs[0].time = value;
        }
      }
    }
    setStamp(newStamp);
  };

  const deleteSub = (sn) => {
    let newStamp = Object.assign([], stamp);
    newStamp = newStamp.filter((x) => x.sn != sn);
    setStamp(newStamp);
  };

  const addSubSub = (sn) => {
    let newStamp = _.cloneDeep(stamp);
    let indexOfSub = newStamp.findIndex((x) => x.sn == sn);
    newStamp[indexOfSub]["subsubs"].push({
      sn: make_serial(6, 6),
      name: "Subtask Name",
      finish: 1,
      time: 1,
    });
    setStamp(newStamp);
  };

  const deleteSubSub = (sn1, sn2) => {
    let newStamp = _.cloneDeep(stamp);
    let indexOfSub = newStamp.findIndex((x) => x.sn == sn1);
    newStamp[indexOfSub]["subsubs"] = newStamp[indexOfSub]["subsubs"].filter(
      (x) => x.sn != sn2
    );
    setStamp(newStamp);
  };

  const addToDoneList = (sn1, sn2, ssname, sspay) => {
    // sn1: sn of the subtask
    // sn2: sn of the subsubtask
    let newStamp = _.cloneDeep(stamp);
    let indexOfSub = newStamp.findIndex((x) => x.sn == sn1);
    let indexOfSubSub = newStamp[indexOfSub]["subsubs"].findIndex(
      (x) => x.sn == sn2
    );
    let sname = newStamp[indexOfSub]["sname"];
    let doneListPrime = _.cloneDeep(doneList);
    // if sn1 is not in doneList, add it
    if (!doneListPrime.some((x) => x.sn == sn1)) {
      doneListPrime.push({
        sn: sn1,
        sname: sname,
        stampId: stampId,
        ss: []
      });
    }
    // Append sn2 to ss of the corresponding element whose sn=sn1
    doneListPrime.forEach((x) => {
      if (x.sn == sn1) {
        x.ss.push({
          sn: sn2,
          name: ssname,
          finish: Number(sspay)
        });
      }
    }
    );
    setDoneList(doneListPrime);

    // Add to subsubHistoryToSync
    let mSubsubHistoryToSync = _.cloneDeep(subsubHistoryToSync);
    mSubsubHistoryToSync.push({
      "sname": sname + "/" + ssname,
      "time": new Date()
    });
    setSubsubHistoryToSync(mSubsubHistoryToSync);

    // Remove sn2 from subsubs of the corresponding element whose sn=sn1
    newStamp[indexOfSub]["subsubs"] = newStamp[indexOfSub]["subsubs"].filter(
      (x) => x.sn != sn2
    );
    setStamp(newStamp);
  };

  const addToDoneListWithRecall = (sn1, sn2, ssname, sspay, daysFromNow) => {
    // Convert daysFromNow to Date
    let today = moment();
    let validFromDate = today.add(daysFromNow, 'days').set('hour', 2).set('minute', 0).set('second', 0).set('millisecond', 0).format("DD/MM/YYYY HH:mm:ss");
    // Add to doneList
    let newStamp = _.cloneDeep(stamp);
    let indexOfSub = newStamp.findIndex((x) => x.sn == sn1);
    let doneListPrime = _.cloneDeep(doneList);
    let sname = newStamp[indexOfSub]["sname"];
    // if sn1 is not in doneList, add it
    if (!doneListPrime.some((x) => x.sn == sn1)) {
      doneListPrime.push({
        sn: sn1,
        sname: sname,
        stampId: stampId,
        ss: []
      });
    }
    // Append sn2 to ss of the corresponding element whose sn=sn1
    doneListPrime.forEach((x) => {
      if (x.sn == sn1) {
        x.ss.push({
          sn: sn2,
          name: ssname,
          finish: Number(sspay)
        });
      }
    }
    );
    setDoneList(doneListPrime);

    // Add to subsubHistoryToSync
    let mSubsubHistoryToSync = _.cloneDeep(subsubHistoryToSync);
    mSubsubHistoryToSync.push({
      "sname": sname + "/" + ssname,
      "time": new Date()
    });
    setSubsubHistoryToSync(mSubsubHistoryToSync);

    const recalledSubsub = newStamp[indexOfSub]["subsubs"].find((x) => x.sn == sn2);
    const recalledDescription = recalledSubsub?.description;
    // Remove sn2 from subsubs of the corresponding element whose sn=sn1
    newStamp[indexOfSub]["subsubs"] = newStamp[indexOfSub]["subsubs"].filter(
      (x) => x.sn != sn2
    );
    // Add the ssname back to the subsubs
    newStamp[indexOfSub]["subsubs"].push({
      sn: make_serial(6, 6),
      name: '[R] ' + ssname,
      finish: Number(sspay),
      validFrom: validFromDate,
      ...(typeof recalledDescription === "string" && recalledDescription.trim() !== ""
        ? { description: recalledDescription }
        : {})
    });
    setStamp(newStamp);
  }

  const addToDoneListForSubs = (sn1) => {
    let newStamp = _.cloneDeep(stamp);
    let indexOfSub = newStamp.findIndex((x) => x.sn == sn1);
    let doneListForSubsPrime = _.cloneDeep(doneListForSubs);
    let sname = newStamp[indexOfSub]["sname"];
    // if sn1 is not in doneListForSubs, add it
    if (!doneListForSubsPrime.some((x) => x.sn == sn1)) {
      let finish = Number(newStamp[indexOfSub]["finish"]);
      doneListForSubsPrime.push({
        sn: sn1,
        sname: sname,
        stampId: stampId,
        finish: finish
      });
    }
    setDoneListForSubs(doneListForSubsPrime);
    console.log(doneListForSubsPrime);
    // Add to subsubHistoryToSync
    let mSubsubHistoryToSync = _.cloneDeep(subsubHistoryToSync);
    mSubsubHistoryToSync.push({
      "sname": sname,
      "time": new Date()
    });
    setSubsubHistoryToSync(mSubsubHistoryToSync);
    // Remove sn1 from stamp
    let filteredStamp = newStamp.filter((x) => x.sn != sn1);
    setStamp(filteredStamp);
  }

  const handleSubTextChange = (e, sn1, sn2, fieldname) => {
    let newStamp = _.cloneDeep(stamp);
    let indexOfSub = newStamp.findIndex((x) => x.sn == sn1);
    let indexOfSubSub = newStamp[indexOfSub]["subsubs"].findIndex(
      (x) => x.sn == sn2
    );
    if (fieldname == "name") {
      newStamp[indexOfSub]["subsubs"][indexOfSubSub]["name"] = e.target.value;
    }
    if (fieldname == "finish") {
      newStamp[indexOfSub]["subsubs"][indexOfSubSub]["finish"] =
        e.target.value;
      /* if (isNumeric(e.target.value)) {
        newStamp[indexOfSub]["subsubs"][indexOfSubSub]["finish"] = Number(
          e.target.value
        );
      } else {
        newStamp[indexOfSub]["subsubs"][indexOfSubSub]["finish"] =
          e.target.value;
      } */
    }
    if (fieldname == "time") {
      newStamp[indexOfSub]["subsubs"][indexOfSubSub]["time"] = e.target.value;
      const updatedSubsubSum = getSubsubTimeSum(newStamp[indexOfSub]);
      if (isNumber(updatedSubsubSum)) {
        applySubTimeUpdate(newStamp[indexOfSub], Number(updatedSubsubSum));
      }
    }
    if (fieldname == "validFrom") {
      // if e.target.value contains the string 'd', it means that the user has entered the number of days
      let xdString = e.target.value
      if (xdString.indexOf('d') > -1) {
        try {
          // remove the 'd' character
          xdString = xdString.replace('d', '')
          // convert to number
          let xd = Number(xdString)
          // convert to Date
          let validFromDate = moment().add(xd, 'days').set('hour', 2).set('minute', 0).set('second', 0).set('millisecond', 0).format("DD/MM/YYYY HH:mm:ss");
          newStamp[indexOfSub]["subsubs"][indexOfSubSub]["validFrom"] = validFromDate
        } catch (error) {
          newStamp[indexOfSub]["subsubs"][indexOfSubSub]["validFrom"] = xdString
        }
      } else {
        newStamp[indexOfSub]["subsubs"][indexOfSubSub]["validFrom"] = xdString
      }
    }
    if (fieldname == "expiryDate") {
      // if e.target.value contains the string 'd', it means that the user has entered the number of days
      let xdString = e.target.value
      if (xdString.indexOf('d') > -1) {
        try {
          // remove the 'd' character
          xdString = xdString.replace('d', '')
          // convert to number
          let xd = Number(xdString)
          // convert to Date
          let validUntilDate = moment().add(xd, 'days').set('hour', 23).set('minute', 59).set('second', 59).set('millisecond', 0).format("DD/MM/YYYY HH:mm:ss");
          newStamp[indexOfSub]["subsubs"][indexOfSubSub]["expiryDate"] = validUntilDate
        } catch (error) {
          newStamp[indexOfSub]["subsubs"][indexOfSubSub]["expiryDate"] = xdString
        }
      } else {
        newStamp[indexOfSub]["subsubs"][indexOfSubSub]["expiryDate"] = xdString
      }
    }
    if (fieldname == "description") {
      newStamp[indexOfSub]["subsubs"][indexOfSubSub]["description"] = e.target.value;
    }
    setStamp(newStamp);
  };

  const setSubsubTimeQuick = (sn1, sn2, value) => {
    handleSubTextChange({ target: { value: String(value) } }, sn1, sn2, "time");
  };

  const addSub = () => {
    let newStamp = _.cloneDeep(stamp);
    newStamp.push({
      bonusCoeff: 1,
      finish: payrate,
      originalFinish: payrate,
      originalTime: 1,
      initialFinish: payrate,
      time: 1,
      sname: "New task",
      sn: make_serial(6, 6),
      subsubs: [],
      type: "subtask",
    });
    setStamp(newStamp);
  };

  const castData = (mData) => {
    let newData = _.cloneDeep(mData)
    console.log("newData", newData.subs[0]);
    newData.subs.forEach(x => {
      // Convert finish, time, originalFinish, originalTime, initialFinish, bonusCoeff to number
      x.finish = Number(x.finish);
      x.time = Number(x.time);
      x.originalFinish = Number(x.originalFinish);
      x.originalTime = Number(x.originalTime);
      x.initialFinish = Number(x.initialFinish);
      x.bonusCoeff = Number(x.bonusCoeff);
      // Convert allowFeedback which is a string to number
      if (x.hasOwnProperty("allowFeedback")) {
        x.allowFeedback = Number(x.allowFeedback)
      }

      // Convert validFromDate and expiryDate to Date
      if (x.hasOwnProperty("validFromDate")) {
        // if validFromDate is not null or empty, convert to Date
        if (x.validFromDate != null && x.validFromDate != "") {
          // parse to date from string

          x.validFromDate = moment(x.validFromDate, "DD/MM/YYYY HH:mm:ss").toDate();
        } else {
          delete x.validFromDate;
        }
      }

      if (x.hasOwnProperty("expiryDate")) {
        if (x.expiryDate != null && x.expiryDate != "") {
          x.expiryDate = moment(x.expiryDate, "DD/MM/YYYY HH:mm:ss").toDate();
        } else {
          delete x.expiryDate;
        }
      }

      // if has subsubs, convert finish to number
      if (x.hasOwnProperty("subsubs")) {
        x.subsubs.forEach(y => {
          const plannedTimeDisplay = Number(y.time ?? 0);
          y.time = Number.isFinite(plannedTimeDisplay)
            ? toSubsubTimeStorage(plannedTimeDisplay)
            : 0;
          y.finish = Number(y.finish);
          if (y.hasOwnProperty("validFrom")) {
            if (y.validFrom != null && y.validFrom != "") {
              y.validFrom = moment(y.validFrom, "DD/MM/YYYY HH:mm:ss").toDate();
            } else {
              delete y.validFrom;
            }
          }
          if ((y.hasOwnProperty("expiryDate") || y.hasOwnProperty("validUntil")) && (y.expiryDate || y.validUntil)) {
            y.expiryDate = moment(y.expiryDate || y.validUntil, "DD/MM/YYYY HH:mm:ss").toDate();
            if (y.hasOwnProperty("validUntil")) {
              delete y.validUntil;
            }
          } else {
            delete y.expiryDate;
            if (y.hasOwnProperty("validUntil")) {
              delete y.validUntil;
            }
          }
          if (y.hasOwnProperty("description")) {
            if (!(typeof y.description === "string" && y.description.trim() !== "")) {
              delete y.description;
            }
          }
        })
      }

      if (!x.hasOwnProperty('tags')) {
        x.tags = ''
      } else {
        // convert tags to lowercase
        x.tags = x.tags.toLowerCase()
        // remove all spaces
        x.tags = x.tags.replace(/\s/g, '')
      }
    })
    newData.totalReward = totalTimeReward;
    return newData;
  }

  const save = async () => {
    setSavingStamp(true)
    // console.log(doneList);

    let newData = _.cloneDeep(data)
    newData.subs = _.cloneDeep(stamp)
    let castedData = castData(newData)

    // Recalculate totalReward
    let totalReward = 0;

    console.log(castedData)
    castedData.subs.forEach((x) => {
      /* if (x.hasOwnProperty("countUp") && x.countUp == 1) {
        // console.log('countUp task found, skip reset time for ' + x.sname)
        // totalReward += x.finish
        // console.log('x', x)
        // console.log('Total reward added', x.finish, 'from', x.sname)
        return; // we do not perform update on countUp tasks
      } */
      if (x.hasOwnProperty("initialFinish")) {
        totalReward += x.initialFinish;
      } else {
        totalReward += x.finish;
      }
      // console.log('Total reward added', x.finish, 'from', x.sname)
    });

    castedData.totalReward = totalReward;


    await setDocx(docx(db, "subtasks", dailySn), castedData);

    // save doneList if there is any
    if (doneList.length > 0) {
      await saveDoneList()

    }

    if (doneListForSubs.length > 0) {
      await saveDoneListForSubs()
    }

    if (doneList.length > 0 || doneListForSubs.length > 0) {
      await saveSubsubHistory()
    }

    await loadStamp()
    try {
      await mqttUpdate()
    } catch (err) {
      console.error('MQTT update failed:', err)
    }

    setSavingStamp(false)
  };

  const saveDoneList = async () => {
    console.log(doneList);
    await setDocx(docx(db, "doneList", 'default'), {
      doneList: _.cloneDeep(doneList)
    });
    // alert("Done list was updated!");
    setDoneList([]);
  }

  const saveSubsubHistory = async () => {
    console.log(subsubHistoryToSync);
    await setDocx(docx(db, "subsubHistory", 'default'), {
      subsubs: _.cloneDeep(subsubHistoryToSync),
    });

    // alert("Subsub history was updated!");
    setSubsubHistoryToSync([]);
  }

  const saveDoneListForSubs = async () => {
    console.log(doneListForSubs);
    await setDocx(docx(db, "doneListForSubs", 'default'), {
      doneListForSubs: _.cloneDeep(doneListForSubs)
    });
    // alert("Done list for subs was updated!");
    setDoneListForSubs([]);
  }

  const resetTime = async () => {
    let docContent = Object.assign({}, data);
    let totalReward = 0;
    if (docContent.subs) {
      docContent.subs.forEach((s) => {
        if (s.hasOwnProperty("countUp") && s.countUp == 1) {
          // console.log('countUp task found, skip reset time for ' + s.sname)
          // totalReward += s.finish
          return; // we do not perform update on countUp tasks
        }
        if (s.hasOwnProperty("originalFinish")) {
          s.finish = s.originalFinish;
          s.initialFinish = s.finish;
        } else {
          console.log(
            "Did not update stamp reward for sub " +
            s.sname +
            " because the originalFinish field was not found"
          );
        }
        if (s.hasOwnProperty("originalTime")) {
          s.time = s.originalTime;
        } else {
          console.log(
            "Did not update stamp reward for sub " +
            s.sname +
            " because the originalTime field was not found"
          );
        }
        if (s.hasOwnProperty("initialFinish")) {
          totalReward += s.initialFinish;
        } else {
          totalReward += s.finish;
        }
      });
      docContent.totalReward = totalReward;
      // console.log('Total reward: ', docContent.totalReward);
      docContent.expiredDate = moment().add(3, "day").toDate();
      docContent.expired = moment().add(3, "day").toISOString();
      console.log("Extend expiredDate to 3 days from today");
      docContent.description = "Task plan for " + moment().format("DD/MM/YYYY");
      let newData = _.cloneDeep(docContent)
      let castedData = castData(newData) // castData uses totalReward from the state, which might not be accurate

      castedData.totalReward = totalReward; // recalculate totalReward 
      setTotalTimeReward(totalReward)

      await setDocx(docx(db, "subtasks", dailySn), castedData);
      await loadStamp()
      try {
        await mqttUpdate()
      } catch (err) {
        console.error('MQTT update failed:', err)
      }
      alert("Reset OK!");
    } else {
      console.log("This stamp does not contain any subsubtasks");
    }
  };

  const resetZero = () => {
    let docContent = _.cloneDeep(data);
    const sourceSubs = stamp?.length ? _.cloneDeep(stamp) : _.cloneDeep(docContent.subs || []);
    let totalReward = 0;
    if (sourceSubs.length) {
      sourceSubs.forEach((s) => {
        if (s.hasOwnProperty("countUp") && s.countUp == 1) {
          return;
        }
        s.finish = 0;
        s.initialFinish = 0;
        s.time = 0;
        zeroOutSubsubTimes(s);
      });
    }
    totalReward = 0;
    docContent.subs = sourceSubs;
    setData({ ...docContent, totalReward: totalReward, subs: sourceSubs });
    setStamp(sourceSubs);
    setOptUpdateFlag(optUpdateFlag + 1);
    // alert("Reset OK!")
  };

  useEffect(() => {
    console.log("Stamp updated");
    // Refresh the total time units label
    // alert('Stamp change')
    let totalTu = 0;
    let totalReward = 0;
    stamp.forEach((s) => {
      if (s.hasOwnProperty('countUp') && s.countUp == 1) {
        return; // skip countUp tasks
      }
      if (s.time) {
        if (isNumber(s.time)) {
          totalTu += Number(s.time);
        }
      }
      if (s.initialFinish) {
        if (isNumber(s.initialFinish)) {
          totalReward += Number(s.initialFinish);
        }
      } else {
        if (isNumber(s.finish)) {
          totalReward += Number(s.finish);
        }
      }
    });
    setTotalTime(totalTu);
    setTotalTimeReward(totalReward);
  }, [stamp, optUpdateFlag]);

  const handleCountUpCheckbox = (sn, checked) => {
    let newStamp = _.cloneDeep(stamp);
    // find the index of property sn in newStamp
    let index = newStamp.findIndex(x => x.sn === sn);

    if (checked) {
      newStamp[index].countUp = 1
      newStamp[index].time = 0
      newStamp[index].finish = payrate
      newStamp[index].initialFinish = payrate
      newStamp[index].originalFinish = payrate
      newStamp[index].originalTime = 0
    } else {
      if (newStamp[index].hasOwnProperty('countUp')) {
        delete newStamp[index].countUp
      }
    }
    setStamp(newStamp);
    setOptUpdateFlag(optUpdateFlag + 1);
  }

  const getRemainingDays = (date) => {
    if (!date) {
      return ''
    }
    try {
      const now = moment();
      const target = moment(date, "DD/MM/YYYY HH:mm:ss");
      if (!target.isValid()) return '?';
      const diffMs = target.diff(now);
      const absDiff = Math.abs(diffMs);
      const totalHours = Math.floor(absDiff / (1000 * 60 * 60));
      const days = Math.floor(totalHours / 24);
      const hours = totalHours % 24;
      const sign = diffMs < 0 ? '-' : '';
      return `${sign}${days}d ${hours}h`;
    } catch (error) {
      return '?'
    }
  }

  const getRelativeDateLabel = (dateStr) => {
    if (!dateStr) return null;
    try {
      const target = moment(dateStr, "DD/MM/YYYY HH:mm:ss");
      if (!target.isValid()) return null;
      const now = moment();
      const diffMs = target.diff(now);
      const absDiff = Math.abs(diffMs);
      const totalHours = Math.floor(absDiff / (1000 * 60 * 60));
      const days = Math.floor(totalHours / 24);
      const hours = totalHours % 24;
      const dayName = target.format('dddd');
      if (diffMs >= 0) {
        return `${dayName}, in ${days}d ${hours}h`;
      } else {
        return `${dayName}, ${days}d ${hours}h ago`;
      }
    } catch (e) {
      return null;
    }
  }

  // This function is the same as the above function, except that it returns the number of days instead of a string
  const getRemainingDaysInNumber = (date) => {
    try {
      let today = moment();
      let expiry = moment(date, "DD/MM/YYYY HH:mm:ss");
      // console.log(date)
      let diff = expiry.diff(today, 'days')
      // console.log(diff)
      return diff;
    } catch (error) {
      return -1
    }
  }

  const handleValidFromDateChange = (sn, date) => {
    if (viewOption != 'all') {
      return // do not allow changing expiry date if viewOption is not 'all'
    }
    let newStamp = _.cloneDeep(stamp);
    // find the index of property sn in newStamp
    let index = newStamp.findIndex(x => x.sn === sn);
    // if date contains the string 'd', it means that the user has entered the number of days
    let xdString = date
    if (xdString.indexOf('d') > -1) {
      try {
        // remove the 'd' character
        xdString = xdString.replace('d', '')
        // convert to number
        let xd = Number(xdString)
        // convert to Date
        let validFromDate = moment().add(xd, 'days').set('hour', 2).set('minute', 0).set('second', 0).set('millisecond', 0).format("DD/MM/YYYY HH:mm:ss");
        newStamp[index].validFromDate = validFromDate
      } catch (error) {
        newStamp[index].validFromDate = xdString
      }
    } else {
      newStamp[index].validFromDate = date
    }
    setStamp(newStamp);
    setOptUpdateFlag(optUpdateFlag + 1);
  }

  const handleExpiryDateChange = (sn, date) => {
    if (viewOption != 'all') {
      return // do not allow changing expiry date if viewOption is not 'all'
    }
    let newStamp = _.cloneDeep(stamp);
    // find the index of property sn in newStamp
    let index = newStamp.findIndex(x => x.sn === sn);
    // if date contains the string 'd', it means that the user has entered the number of days
    let xdString = date
    if (xdString.indexOf('d') > -1) {
      try {
        // remove the 'd' character
        xdString = xdString.replace('d', '')
        // convert to number
        let xd = Number(xdString)
        // convert to Date
        let expiryDate = moment().add(xd, 'days').set('hour', 2).set('minute', 0).set('second', 0).set('millisecond', 0).format("DD/MM/YYYY HH:mm:ss");
        newStamp[index].expiryDate = expiryDate
      } catch (error) {
        newStamp[index].expiryDate = xdString
      }
    } else {
      newStamp[index].expiryDate = date
    }
    setStamp(newStamp);
    setOptUpdateFlag(optUpdateFlag + 1);
  }

  const toFixed = (number, precision) => {
    try {
      return Number(number).toFixed(precision);
    } catch (error) {
      return "N/A";
    }
  }

  const roundToSecondDecimal = (number) => {
    try {
      return Number(number).toFixed(2);
    } catch (error) {
      return "N/A";
    }
  }


  const makeOriginal = () => {
    let newStamp = _.cloneDeep(stamp);
    newStamp.forEach((s) => {
      if (s.hasOwnProperty("countUp") && s.countUp == 1) {
        return; // skip countUp tasks
      }
      s.originalTime = s.time;
      s.originalFinish = s.finish;
      s.initialFinish = Number(s.finish);
    });
    setStamp(newStamp);
    setOptUpdateFlag(optUpdateFlag + 1);
  }

  const filterStampByViewOption = (viwOption, stmp) => {
    console.log("filterStampByViewOption")
    //console.log(viwOption, stmp)
    if (!stmp || stmp.length === 0 || !viwOption) {
      return []
    }
    if (viwOption === "all") {
      return stmp
    }
    else if (viwOption === "notpostponed") {
      return stmp.filter((s) => {
        if (!s.validFromDate) {
          return true
        }
        try {
          let validFr = moment(s.validFromDate, "DD/MM/YYYY HH:mm:ss")
          return validFr <= moment()
        } catch (error) {
          console.log(error)
        }
      })
    } else if (viwOption === "cart") {
      return stmp.filter(s => s.finish > 0)
    }
  }

  const getHoursMinutesFromMinutes = (minutes) => {
    let hours = Math.floor(minutes / 60)
    let mins = minutes % 60
    if (mins < 10) {
      mins = '0' + mins
    }
    return hours + ':' + mins
  }

  const starSubSub = (sn1, sn2) => {
    let newStamp = _.cloneDeep(stamp);
    let indexOfSub = newStamp.findIndex((x) => x.sn == sn1);
    let indexOfSubSub = newStamp[indexOfSub]["subsubs"].findIndex(
      (x) => x.sn == sn2
    );
    let subsubDescription = newStamp[indexOfSub]["subsubs"][indexOfSubSub]["name"]

    // if subsubDescription begins with '***'
    if (subsubDescription.indexOf('***') == 0) {
      // remove the stars
      newStamp[indexOfSub]["subsubs"][indexOfSubSub]["name"] = subsubDescription.replace('***', '')
    } else if (subsubDescription.indexOf('**') == 0) {
      // make it three stars
      newStamp[indexOfSub]["subsubs"][indexOfSubSub]["name"] = subsubDescription.replace('**', '***')
    } else if (subsubDescription.indexOf('*') == 0) {
      // make it two stars
      newStamp[indexOfSub]["subsubs"][indexOfSubSub]["name"] = subsubDescription.replace('*', '**')
    } else {
      // make it one star
      newStamp[indexOfSub]["subsubs"][indexOfSubSub]["name"] = '*' + subsubDescription
    }
    setStamp(newStamp);
  }

  const loadTemplates = () => {
    let mDailyTemplates = []

    const documentSnapshot = getDocx(docx(db, "templates", "daily"));

    console.log('Dokument snapshot', documentSnapshot)

    documentSnapshot.then((doc) => {
      console.log('Doc', doc)
      if (doc.exists()) {
        let data = doc.data(); // data looks like [{name: 'xxx', subs: [{sname : 'xx', time: x, finish: x}, {sname:...}]}]
        // console.log(data)
        if (data.hasOwnProperty('subs')) {
          setDailyTemplates(data.subs)
        }
      } else {
        console.log("Document does not exist");
      }
    });
  }

  const saveTemplate = () => {
    let newTemplate = []
    stamp.forEach((s) => {
      let newSub = _.cloneDeep(s)
      if (newSub.hasOwnProperty('validFromDate')) {
        newSub.validFromDate = moment(newSub.validFromDate, "DD/MM/YYYY HH:mm:ss").toISOString()
      }
      if (newSub.hasOwnProperty('expiryDate')) {
        newSub.expiryDate = moment(newSub.expiryDate, "DD/MM/YYYY HH:mm:ss").toISOString()
      }
      if (newSub.hasOwnProperty('subsubs')) {
        newSub.subsubs.forEach(ss => {
          if (ss.hasOwnProperty('validFrom')) {
            ss.validFrom = moment(ss.validFrom, "DD/MM/YYYY HH:mm:ss").toISOString()
          }
          if (ss.hasOwnProperty('expiryDate')) {
            ss.expiryDate = moment(ss.expiryDate, "DD/MM/YYYY HH:mm:ss").toISOString()
          }
          if (ss.hasOwnProperty('validUntil')) {
            ss.expiryDate = moment(ss.validUntil, "DD/MM/YYYY HH:mm:ss").toISOString()
            delete ss.validUntil
          }
        })
      }
      newTemplate.push(newSub)
    })
    // Update the document for DB
    let newDailyTemplates = _.cloneDeep(dailyTemplates)
    // Check if the template name already exists
    let index = newDailyTemplates.findIndex(x => x.name.toLowerCase() == nameDailyTemplate.toLowerCase())
    if (index > -1) {
      // The template already exists, update it
      newDailyTemplates[index].subs = newTemplate
    } else {
      // The template does not exist, add it
      newDailyTemplates.push({
        name: nameDailyTemplate,
        subs: newTemplate
      })
    }

    // Update the database
    setDocx(docx(db, "templates", "daily"), {
      subs: newDailyTemplates
    }).then(() => {
      alert('Template saved')
      loadTemplates()
    })

  }

  const appendFromTemplate = () => {
    dailyTemplates.forEach((t) => {
      if (t.name == selectedDailyTemplate) {
        // The template is t
        let newStamp = _.cloneDeep(stamp);
        // console.log(newStamp)
        t.subs.forEach((ts) => {
          // For each subtask in the template, check if it is already in the stamp
          let index = newStamp.findIndex(x => x.sname.toLowerCase() == ts.sname.toLowerCase())
          console.log('TS: ')
          console.log(ts)
          try {
            if (ts.hasOwnProperty('validFromDate')) {
              // Check if ts.validFromDate is an ISO string
              if (ts.validFromDate.indexOf('T') > -1) {
                ts.validFromDate = moment(ts.validFromDate).format('DD/MM/YYYY HH:mm:ss')
              }
            }
            if (ts.hasOwnProperty('expiryDate')) {
              // Check if ts.expiryDate is an ISO string
              if (ts.expiryDate.indexOf('T') > -1) {
                ts.expiryDate = moment(ts.expiryDate).format('DD/MM/YYYY HH:mm:ss')
              }
            }
            if (ts.hasOwnProperty('subsubs')) {
              ts.subsubs.forEach(ss => {
                if (ss.hasOwnProperty('validFrom')) {
                  if (ss.validFrom.indexOf('T') > -1) {
                    ss.validFrom = moment(ss.validFrom).format('DD/MM/YYYY HH:mm:ss')
                  }
                }
                if (ss.hasOwnProperty('expiryDate')) {
                  if (ss.expiryDate.indexOf('T') > -1) {
                    ss.expiryDate = moment(ss.expiryDate).format('DD/MM/YYYY HH:mm:ss')
                  }
                }
                if (ss.hasOwnProperty('validUntil')) {
                  if (ss.validUntil.indexOf('T') > -1) {
                    ss.expiryDate = moment(ss.validUntil).format('DD/MM/YYYY HH:mm:ss')
                    delete ss.validUntil
                  }
                }
              })
            }
          } catch (error) {
            console.log('Cannot format date')
            console.log(error)
          }
          if (index > -1) {
            // This subtask is already in the stamp
            console.log('Found subtask', ts.sname, 'in the stamp')

            let oldSubs = []

            console.log('New stamp', newStamp)

            if (newStamp[index].hasOwnProperty('subsubs') && ts.hasOwnProperty('subsubs')) {
              oldSubs = _.cloneDeep(newStamp[index].subsubs)
              newStamp[index] = _.cloneDeep(ts) // replace the subtask in the stamp with the subtask in the template
              oldSubs.forEach((os) => {
                let indexx = newStamp[index].subsubs.findIndex(x => x.name == os.name)
                if (indexx == -1) {
                  newStamp[index].subsubs.push(os)
                }
              })
            }

          } else {
            // This subtask is not in the stamp
            newStamp.push(_.cloneDeep(ts))
          }
        })
        console.log(newStamp)
        setStamp(newStamp)
      }
    })
  }

  const transferTemplate = () => {
    console.log('Selected template', selectedDailyTemplate)
    console.log('Daily templates', dailyTemplates)
    dailyTemplates.forEach((t) => {
      if (t.name == selectedDailyTemplate) {
        // The template is t
        let newStamp = _.cloneDeep(stamp);
        newStamp.forEach((s) => {
          // For each subtask in stamp, check if it is in the template
          let index = t.subs.findIndex(x => x.sname.toLowerCase() == s.sname.toLowerCase())
          if (index > -1) {
            // console.log('Found subtask', s.sname, 'in the template')
            // This subtask is in the template
            // Transfer the time and pay
            s.time = Number(t.subs[index].time)
            s.finish = Number(t.subs[index].finish)
            s.initialFinish = Number(t.subs[index].finish)
            // console.log('New time and pay', s.time, s.finish)
          } else {
            s.time = 0
            s.finish = 0
            s.initialFinish = 0
          }
        })
        // console.log(newStamp)
        setStamp(newStamp)
      }
    })
  }

  const deleteTemplate = () => {
    if (selectedDailyTemplate == '') {
      alert('Please choose a template to delete')
      return
    }
    let newDailyTemplates = _.cloneDeep(dailyTemplates)
    let index = newDailyTemplates.findIndex(x => x.name == selectedDailyTemplate)
    if (index > -1) {
      newDailyTemplates.splice(index, 1) // remove the template
      setDocx(docx(db, "templates", "daily"), {
        subs: newDailyTemplates
      }).then(() => {
        alert('Template deleted')
        setNameDailyTemplate('')
        setSelectedDailyTemplate('')
        loadTemplates()
      })
    }
  }

  const promoteSubSub = (sname, ssname) => {
    const stampCopy = _.cloneDeep(stamp)
    const index = stampCopy.findIndex(x => x.sname == sname)
    const indexx = stampCopy[index].subsubs.findIndex(x => x.name == ssname)
    // console.log('Promote subsub', ssname, 'from', sname)
    // console.log('Index', index, indexx)
    if (indexx > 0) {
      let temp = stampCopy[index].subsubs[indexx]
      // console.log('Temp', temp)
      stampCopy[index].subsubs[indexx] = stampCopy[index].subsubs[indexx - 1]
      stampCopy[index].subsubs[indexx - 1] = temp
      setStamp(stampCopy)
    }
  }

  const promoteSubSubToTop = (sname, ssname) => {
    const stampCopy = _.cloneDeep(stamp)
    const index = stampCopy.findIndex(x => x.sname == sname)
    const indexx = stampCopy[index].subsubs.findIndex(x => x.name == ssname)
    // console.log('Promote subsub to top', ssname, 'from', sname)
    // console.log('Index', index, indexx)
    if (indexx > 0) {
      let temp = stampCopy[index].subsubs[indexx]
      // console.log('Temp', temp)
      stampCopy[index].subsubs.splice(indexx, 1)
      stampCopy[index].subsubs.unshift(temp)
      setStamp(stampCopy)
    }
  }

  const demoteSubSub = (sname, ssname) => {
    const stampCopy = _.cloneDeep(stamp)
    const index = stampCopy.findIndex(x => x.sname == sname)
    const indexx = stampCopy[index].subsubs.findIndex(x => x.name == ssname)
    // console.log('Demote subsub', ssname, 'from', sname)
    // console.log('Index', index, indexx)
    if (indexx < stampCopy[index].subsubs.length - 1) {
      let temp = stampCopy[index].subsubs[indexx]
      // console.log('Temp', temp)
      stampCopy[index].subsubs[indexx] = stampCopy[index].subsubs[indexx + 1]
      stampCopy[index].subsubs[indexx + 1] = temp
      setStamp(stampCopy)
    }
  }

  const promoteSub = (sname) => {
    const stampCopy = _.cloneDeep(stamp)
    const index = stampCopy.findIndex(x => x.sname == sname)
    console.log('Promote sub', sname)
    console.log('Index', index)
    if (index > 0) {
      let temp = stampCopy[index]
      // console.log('Temp', temp)
      stampCopy[index] = stampCopy[index - 1]
      stampCopy[index - 1] = temp
      setStamp(stampCopy)
    }
  }

  const demoteSub = (sname) => {
    const stampCopy = _.cloneDeep(stamp)
    const index = stampCopy.findIndex(x => x.sname == sname)
    // console.log('Demote sub', sname)
    // console.log('Index', index)
    if (index < stampCopy.length - 1) {
      let temp = stampCopy[index]
      // console.log('Temp', temp)
      stampCopy[index] = stampCopy[index + 1]
      stampCopy[index + 1] = temp
      setStamp(stampCopy)
    }
  }

  const promoteSubToTop = (sname) => {
    const stampCopy = _.cloneDeep(stamp)
    const index = stampCopy.findIndex(x => x.sname == sname)
    // console.log('Promote sub to top', sname)
    // console.log('Index', index)
    if (index > 0) {
      let temp = stampCopy[index]
      stampCopy.splice(index, 1)
      stampCopy.unshift(temp)
      setStamp(stampCopy)
    }
  }

  const toggleSubSubDetails = (subsubSn) => {
    const newSet = new Set(expandedSubSubDetails);
    if (newSet.has(subsubSn)) {
      newSet.delete(subsubSn);
    } else {
      newSet.add(subsubSn);
    }
    setExpandedSubSubDetails(newSet);
  }

  const syncBalanceAndReload = async () => {
    await syncBalance()
    try {
      await mqttUpdate()
    } catch (err) {
      console.error('MQTT update failed:', err)
    }
    // Refresh the page
    window.location.reload()
  }

  return (
    <div className="AppRootDesktop">
      <div className='AppRootInnerOverlay'>
        <Container ref={editPageRef} fluid className="edit-page">
          <div ref={actionBarRef} className="action-bar">
            <h1>Edit Tasks</h1>
            <div style={{ flex: '0 0 auto', flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
              <div className="action-bar-stats">
                <div>Time units: {totalTime.toFixed(0)} / {getHoursMinutesFromMinutes(totalTime * 25)}</div>
                <div>Init pay: {totalTimeReward.toFixed(2)}</div>
              </div>
              <div>
                {savingStamp && <Spinner style={{ marginRight: 4 }} animation="border" variant="primary" />}
              </div>
              {!savingStamp && <div>
                <Button
                  variant="success"
                  onClick={() => {
                    save();
                  }}
                >
                  <AiFillSave></AiFillSave> <span className="save-button-text">SAVE</span>
                </Button>
              </div>}
              <div>
                <Button
                  variant="primary"
                  onClick={() => {
                    resetTime();
                  }}
                >
                  <BiReset></BiReset>
                </Button>
              </div>
              <div>
                <Button
                  variant="danger"
                  onClick={() => {
                    resetZero();
                  }}
                >
                  <BiReset></BiReset>
                </Button>
              </div>
              <div>
                <Button
                  variant="success"
                  onClick={() => {
                    syncBalanceAndReload();
                  }}
                >
                  <FaSync></FaSync>
                </Button>
              </div>

            </div>
          </div>

          {canShowCartSummary && (
            <div className="AllTasksSummarySlot">
              <div className="AllTasksSummary">
                <div className="AllTasksSummaryHeader">
                  <div>CART</div>
                  <div className="AllTasksSummaryGlobalToggle">
                    <Form.Check
                      type='switch'
                      id="cartGlobalToggle"
                      label={showOnlySelected ? 'Selected' : 'All'}
                      onChange={(e) => setShowOnlySelected(e.target.checked)}
                      checked={showOnlySelected}
                    />
                  </div>
                </div>
                {(showOnlySelected ? stamp.filter((s) => isNumber(s.time) && Number(s.time) > 0) : stamp).map((sub, subIndex) => {
                  const isSelected = isNumber(sub.time) && Number(sub.time) > 0;
                  const hasSubsubs = sub.hasOwnProperty('subsubs') && sub.subsubs && sub.subsubs.length > 0;
                  const subsubTimeSum = getSubsubTimeSum(sub);
                  const showSubsubTimeWarning = shouldShowSubsubTimeWarning(sub, subsubTimeSum);
                  // Find the actual index in the full stamp array for drag-and-drop
                  const actualIndex = stamp.findIndex((x) => x.sn === sub.sn);
                  const subtaskCountdownLabel = getCountdownLabel(sub.expiryDate);
                  const subtaskCountdownColor = getCountdownColor(sub.expiryDate);
                  return (
                    <div
                      key={sub.sn}
                      className={`AllTasksSummaryBlock ${isSelected ? 'AllTasksSummaryBlockSelected' : ''}`}
                      draggable
                      onDragStart={(e) => {
                        e.dataTransfer.effectAllowed = 'move';
                        e.dataTransfer.setData('text/plain', JSON.stringify({ type: 'subtask', index: actualIndex, sn: sub.sn }));
                        e.currentTarget.style.opacity = '0.5';
                      }}
                      onDragEnd={(e) => {
                        e.currentTarget.style.opacity = '1';
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.dataTransfer.dropEffect = 'move';
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        const data = JSON.parse(e.dataTransfer.getData('text/plain'));
                        if (data.type === 'subtask' && data.index !== actualIndex) {
                          const newStamp = _.cloneDeep(stamp);
                          const draggedItem = newStamp[data.index];
                          newStamp.splice(data.index, 1);
                          newStamp.splice(actualIndex, 0, draggedItem);
                          setStamp(newStamp);
                        }
                      }}
                    >
                      <div 
                        className="AllTasksSummaryTitleRow"
                        onClick={(e) => {
                          e.stopPropagation();
                          const element = document.getElementById(`subtask-${sub.sn}`);
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            // Add highlight animation
                            element.classList.add('scroll-highlight');
                            setTimeout(() => {
                              element.classList.remove('scroll-highlight');
                            }, 1500);
                          }
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="AllTasksSummaryTitle">{sub.sname}</div>
                        {showSubsubTimeWarning && (
                          <FaExclamationTriangle
                            className="AllTasksSummaryWarningIcon"
                            title="Subsub time sum does not match task time"
                          />
                        )}
                        <div className="AllTasksSummaryBlank"></div>
                        <div className="AllTasksSummaryTime">{toFixed(sub.time, 0)}</div>
                        {subtaskCountdownLabel && (
                          <span className="AllTasksSummaryCartCalendar" style={{ color: subtaskCountdownColor }}>
                            / <MdCalendarToday style={{ verticalAlign: 'middle', marginBottom: 2 }} /> ({subtaskCountdownLabel})
                          </span>
                        )}
                      </div>
                      {hasSubsubs && (
                        <div className="AllTasksSummarySubsubs">
                          {sub.subsubs.map((subsub, subsubIndex) => {
                            // Find the actual index in the subsubs array
                            const actualSubsubIndex = sub.subsubs.findIndex((x) => x.sn === subsub.sn);
                            const validityStatus = getSubsubValidityStatus(subsub);
                            return (
                              <div
                                key={subsub.sn}
                                className="AllTasksSummarySubsubBlock"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const element = document.getElementById(`subsubtask-${subsub.sn}`);
                                  if (element) {
                                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    // Add highlight animation
                                    element.classList.add('scroll-highlight');
                                    setTimeout(() => {
                                      element.classList.remove('scroll-highlight');
                                    }, 1500);
                                  }
                                }}
                                style={{ cursor: 'pointer', ...validityStatus.borderStyle }}
                                draggable
                                onDragStart={(e) => {
                                  e.stopPropagation();
                                  e.dataTransfer.effectAllowed = 'move';
                                  e.dataTransfer.setData('text/plain', JSON.stringify({
                                    type: 'subsub',
                                    subIndex: actualIndex,
                                    subsubIndex: actualSubsubIndex,
                                    subSn: sub.sn,
                                    subsubSn: subsub.sn
                                  }));
                                  e.currentTarget.style.opacity = '0.5';
                                }}
                                onDragEnd={(e) => {
                                  e.currentTarget.style.opacity = '1';
                                }}
                                onDragOver={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  e.dataTransfer.dropEffect = 'move';
                                }}
                                onDrop={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const data = JSON.parse(e.dataTransfer.getData('text/plain'));
                                  if (data.type === 'subsub' && data.subSn === sub.sn && data.subsubIndex !== actualSubsubIndex) {
                                    const newStamp = _.cloneDeep(stamp);
                                    const subIndexInStamp = newStamp.findIndex((x) => x.sn === sub.sn);
                                    if (subIndexInStamp !== -1 && newStamp[subIndexInStamp].subsubs) {
                                      const draggedSubsub = newStamp[subIndexInStamp].subsubs[data.subsubIndex];
                                      newStamp[subIndexInStamp].subsubs.splice(data.subsubIndex, 1);
                                      newStamp[subIndexInStamp].subsubs.splice(actualSubsubIndex, 0, draggedSubsub);
                                      setStamp(newStamp);
                                    }
                                  }
                                }}
                              >
                                <div className="AllTasksSummarySubsubTitle">{subsub.name || 'Unnamed'}</div>
                                <div className="AllTasksSummarySubsubTime">{toFixed(subsub.time || 0, 0)}</div>
                                {validityStatus.label && (
                                  <div className="AllTasksSummarySubsubTiming" style={{ color: validityStatus.labelColor }}>
                                    {validityStatus.label}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div className="BodyEdit">
            <div className="ViewOptions">
              <Button variant={`${viewOption === 'all' ? 'primary' : 'outline-primary'}`} onClick={() => { setViewOption("all") }}>ALL</Button>
              <Button variant={`${viewOption === 'notpostponed' ? 'danger' : 'outline-danger'}`} onClick={() => { setViewOption("notpostponed") }}>NOT POSTPONED</Button>
              <Button variant={`${viewOption === 'cart' ? 'success' : 'outline-success'}`} onClick={() => { setViewOption("cart") }}>CART</Button>
            </div>
            <div className="TemplateControls">
              <div style={{ display: templateExpanded ? "none" : "flex" }} onClick={() => setTemplateExpanded(!templateExpanded)}>
                <div style={{ marginRight: 4 }}><FaChevronDown></FaChevronDown></div> Templates
              </div>
              <div style={{ display: templateExpanded ? "flex" : "none", flexDirection: 'column' }}>
                <div>Template Name</div>
                <div>
                  <Form.Select aria-label="Choose a template" onChange={(e) => { setSelectedDailyTemplate(e.target.value); setNameDailyTemplate(e.target.value) }}>
                    <option>Choose a template</option>
                    {dailyTemplates.map((t) => {
                      return <option value={t.name}>{t.name}</option>
                    })}
                  </Form.Select>
                </div>
                <div>
                  <div>
                    Save As
                  </div>
                  <div>
                    <input type="text" value={nameDailyTemplate} onChange={(e) => { setNameDailyTemplate(e.target.value) }}></input>
                  </div>
                </div>
                <div className="TemplateControlButtons">
                  <Button variant="primary" onClick={() => { transferTemplate() }}><FaAngleRight></FaAngleRight> Transfer</Button>
                  <Button variant="primary" onClick={() => { appendFromTemplate() }}><FaPlus></FaPlus> Append</Button>
                  <Button variant="success" onClick={() => { saveTemplate() }}><MdSave></MdSave> Override</Button>
                  <Button variant="danger" onClick={() => { deleteTemplate() }}><MdDelete></MdDelete> Delete</Button>
                </div>
              </div>
            </div>
            {!enableDelete && (
              <Alert variant="danger" className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <Alert.Heading as="h5" className="mb-2">
                    <strong>⚠️ CAUTION</strong>
                  </Alert.Heading>
                  <p className="mb-0">
                    Unsynchronized reports are present. Please{" "}
                    <Alert.Link href="#" onClick={(e) => { e.preventDefault(); syncBalanceAndReload(); }}>
                      sync
                    </Alert.Link>{" "}
                    with the app.
                  </p>
                </div>
              </Alert>
            )}
            <div style={{ height: 12 }}></div>
            <Row>
              {filterStampByViewOption(viewOption, stamp).filter(sub => {
                if (!filterTag) return true;
                if (!sub.tags) return false;
                return sub.tags.split(',').includes(filterTag);
              }).map((sub) => {
                const subsubTimeSum = getSubsubTimeSum(sub);
                const showSubsubTimeWarning = shouldShowSubsubTimeWarning(sub, subsubTimeSum);
                return (
                <Col xs={12} key={sub.sn}>
                  <div 
                    id={`subtask-${sub.sn}`}
                    data-subtask-id={sub.sn}
                    className={`${getRemainingDaysInNumber(sub.validFromDate) > 0 ? 'SubTaskGrayedOut' : ''} ${sub.finish > 0 ? 'SubTaskSelect' : ''} task-card`}>
                    <div className="task-card__header">
                      <div className="task-card__title-block">
                        <span className="task-card__label">Name</span>
                        <input
                          type="text"
                          className="form-control task-card__title-input"
                          value={sub.sname}
                          onChange={(e) => {
                            handleTextChange(e, "sname", sub.sn);
                          }}
                        ></input>
                      </div>
                      <div className="task-card__status-item d-none d-md-flex">
                        <span className="task-card__status-label">Valid from</span>
                        <span className="task-card__status-value">{getRemainingDays(sub.validFromDate)}</span>
                      </div>
                      <div className="task-card__status-item d-none d-md-flex">
                        <span className="task-card__status-label">Expiry date</span>
                        <span className="task-card__status-value">{getRemainingDays(sub.expiryDate)}</span>
                      </div>
                    </div>
                    {/* Tags Section */}
                    {sub.tags && sub.tags.length > 0 && (
                      <div className="task-card__tags" style={{ padding: "0 0 4px 0", display: "flex", flexWrap: "wrap", gap: "4px" }}>
                        {sub.tags.split(',').filter(t => t.trim() !== '').map((tag, tagIndex) => {
                          const isSelected = filterTag === tag;
                          return (
                            <Badge
                              key={tagIndex}
                              bg={isSelected ? "primary" : "secondary"}
                              style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}
                              onClick={() => {
                                if (isSelected) {
                                  setFilterTag(null);
                                } else {
                                  setFilterTag(tag);
                                }
                              }}
                            >
                              {tag.toUpperCase()}
                              {isSelected && <MdClose size={14} />}
                            </Badge>
                          );
                        })}
                      </div>
                    )}

                    <div className="task-card__time-bar">
                      <div className="task-card__label">Time</div>
                      <div className="time-buttons">
                        {TIME_SLOTS.map((slot) => (
                          <Button
                            key={`${sub.sn}-time-${slot}`}
                            variant={getTimeButtonVariant(sub.time, slot)}
                            onClick={() => setTimeByButton(sub.sn, slot)}
                          >
                            {slot}
                          </Button>
                        ))}
                      </div>
                    </div>
                    {showSubsubTimeWarning && (
                      <Alert variant="warning" className="subsub-time-warning">
                        Subsub time sum ({toFixed(subsubTimeSum, 2)}) does not match task time ({toFixed(sub.time, 2)}).
                      </Alert>
                    )}

                    <div className="task-card__details-section">
                      <div
                        className="task-card__details-header"
                        onClick={() => {
                          const newExpanded = new Set(expandedTaskDetails);
                          if (newExpanded.has(sub.sn)) {
                            newExpanded.delete(sub.sn);
                          } else {
                            newExpanded.add(sub.sn);
                          }
                          setExpandedTaskDetails(newExpanded);
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
                          <FaChevronDown
                            style={{
                              transform: expandedTaskDetails.has(sub.sn) ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "transform 0.2s ease"
                            }}
                          />
                          <span className="task-card__field-label">TASK DETAILS</span>
                        </div>
                      </div>
                      {expandedTaskDetails.has(sub.sn) && (
                        <div className="task-card__grid">
                          <div className="task-card__field">
                            <span className="task-card__field-label">Time units</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.time}
                              onChange={(e) => {
                                handleTextChange(e, "time", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">
                              Pay{" "}
                              <small>
                                ({sub.hasOwnProperty("initialFinish") ? sub.initialFinish : "N/A"})
                              </small>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.finish}
                              onChange={(e) => {
                                handleTextChange(e, "pay", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Bonus coeff</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.bonusCoeff}
                              onChange={(e) => {
                                handleTextChange(e, "bonusCoeff", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Orig time</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.originalTime}
                              onChange={(e) => {
                                handleTextChange(e, "originalTime", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Orig pay</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.originalFinish}
                              onChange={(e) => {
                                handleTextChange(e, "originalFinish", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field task-card__field--switch">
                            <span className="task-card__field-label">Count up</span>
                            <Form.Check
                              type="switch"
                              id={`countUpSwitch-${sub.sn}`}
                              label=""
                              onChange={(e) => handleCountUpCheckbox(sub.sn, e.target.checked)}
                              checked={sub.hasOwnProperty("countUp") && sub.countUp == 1}
                            />
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">
                              Valid from{" "}
                              <small>{getRemainingDays(sub.validFromDate)}</small>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.validFromDate ? sub.validFromDate : ""}
                              onChange={(e) => {
                                handleValidFromDateChange(sub.sn, e.target.value);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">
                              Expiry date <small>{getRemainingDays(sub.expiryDate)}</small>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.expiryDate ? sub.expiryDate : ""}
                              onChange={(e) => {
                                handleExpiryDateChange(sub.sn, e.target.value);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Min minutes for feedback inquiry</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.allowFeedback ? sub.allowFeedback : ""}
                              onChange={(e) => {
                                handleTextChange(e, "allowFeedback", sub.sn);
                              }}
                            ></input>
                          </div>
                          <div className="task-card__field">
                            <span className="task-card__field-label">Tags</span>
                            <input
                              type="text"
                              className="form-control"
                              value={sub.tags ? sub.tags : ""}
                              onChange={(e) => {
                                handleTextChange(e, "tags", sub.sn);
                              }}
                            ></input>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="task-card__subsubs">
                      {sub.subsubs.map((ss, subsubIndex) => {
                        const actualSubsubIndex = sub.subsubs.findIndex((x) => x.sn === ss.sn);
                        const validityStatus = getSubsubValidityStatus(ss);
                        return (
                          <div
                            key={ss.sn}
                            id={`subsubtask-${ss.sn}`}
                            data-subsubtask-id={ss.sn}
                            draggable
                            className="SubSubTaskEdit"
                            style={validityStatus.borderStyle}
                            onDragStart={(e) => {
                              e.stopPropagation();
                              e.dataTransfer.effectAllowed = 'move';
                              e.dataTransfer.setData('text/plain', JSON.stringify({
                                type: 'subsub',
                                subSn: sub.sn,
                                subsubIndex: actualSubsubIndex,
                                subsubSn: ss.sn
                              }));
                              e.currentTarget.style.opacity = '0.5';
                            }}
                            onDragEnd={(e) => {
                              e.currentTarget.style.opacity = '1';
                            }}
                            onDragOver={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              e.dataTransfer.dropEffect = 'move';
                              e.currentTarget.style.borderTop = '2px solid #007bff';
                            }}
                            onDragLeave={(e) => {
                              e.currentTarget.style.borderTop = '';
                            }}
                            onDrop={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              e.currentTarget.style.borderTop = '';
                              const data = JSON.parse(e.dataTransfer.getData('text/plain'));
                              if (data.type === 'subsub' && data.subSn === sub.sn && data.subsubIndex !== actualSubsubIndex) {
                                const newStamp = _.cloneDeep(stamp);
                                const subIndexInStamp = newStamp.findIndex((x) => x.sn === sub.sn);
                                if (subIndexInStamp !== -1 && newStamp[subIndexInStamp].subsubs) {
                                  const draggedSubsub = newStamp[subIndexInStamp].subsubs[data.subsubIndex];
                                  newStamp[subIndexInStamp].subsubs.splice(data.subsubIndex, 1);
                                  newStamp[subIndexInStamp].subsubs.splice(actualSubsubIndex, 0, draggedSubsub);
                                  setStamp(newStamp);
                                }
                              }
                            }}
                          >
                            <Row>
                              <Col xs={12} md={5}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span
                                    onClick={() => toggleSubSubDetails(ss.sn)}
                                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', flexShrink: 0 }}
                                  >
                                    {expandedSubSubDetails.has(ss.sn) ? (
                                      <FaChevronDown style={{ fontSize: '12px' }} />
                                    ) : (
                                      <FaAngleRight style={{ fontSize: '12px' }} />
                                    )}
                                  </span>
                                  <div style={{ position: 'relative', flex: 1 }}>
                                    <FaTag style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: '14px', pointerEvents: 'none' }} />
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={ss.name}
                                      onChange={(e) =>
                                        handleSubTextChange(e, sub.sn, ss.sn, "name")
                                      }
                                      style={{ paddingLeft: '32px' }}
                                    ></input>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12} md={3}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ width: '24px', flexShrink: 0 }}></span>
                                  <div style={{ position: 'relative', flex: 1 }}>
                                    <FaClock style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: '14px', pointerEvents: 'none' }} />
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={ss.time}
                                      onChange={(e) =>
                                        handleSubTextChange(e, sub.sn, ss.sn, "time")
                                      }
                                      onFocus={() => setActiveSubsubTimeInput(`${sub.sn}-${ss.sn}`)}
                                      onBlur={() => setActiveSubsubTimeInput(null)}
                                      style={{ paddingLeft: '32px' }}
                                    ></input>
                                    {activeSubsubTimeInput === `${sub.sn}-${ss.sn}` && (
                                      <div
                                        style={{
                                          position: 'absolute',
                                          left: '0',
                                          right: '0',
                                          top: '-34px',
                                          display: 'flex',
                                          gap: '6px',
                                          alignItems: 'center',
                                          zIndex: 5,
                                        }}
                                        onMouseDown={(e) => e.preventDefault()}
                                      >
                                        {SUBSUB_TIME_OPTIONS.map((option) => (
                                          <button
                                            key={`${ss.sn}-time-option-${option}`}
                                            type="button"
                                            className="btn btn-light btn-sm"
                                            style={{ padding: '2px 8px', fontSize: '12px' }}
                                            onClick={() => {
                                              setSubsubTimeQuick(sub.sn, ss.sn, option);
                                              setActiveSubsubTimeInput(null);
                                            }}
                                          >
                                            {option}
                                          </button>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12} md={4}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span style={{ width: '24px', flexShrink: 0 }}></span>
                                  <div style={{ position: 'relative', flex: 1 }}>
                                    <FaCoins style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: '14px', pointerEvents: 'none' }} />
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={ss.finish}
                                      onChange={(e) =>
                                        handleSubTextChange(e, sub.sn, ss.sn, "finish")
                                      }
                                      style={{ paddingLeft: '32px' }}
                                    ></input>
                                  </div>
                                </div>
                              </Col>
                              {expandedSubSubDetails.has(ss.sn) && (
                                <div className="SubSubTaskDetails">
                                  <Col xs={12} md={6}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <span style={{ width: '24px', flexShrink: 0 }}></span>
                                      <div style={{ position: 'relative', flex: 1 }}>
                                        <FaCalendarAlt style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: '14px', pointerEvents: 'none' }} />
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={ss.validFrom ? ss.validFrom : ""}
                                          onChange={(e) =>
                                            handleSubTextChange(e, sub.sn, ss.sn, "validFrom")
                                          }
                                          placeholder="Valid from (DMY HMS)"
                                          style={{ paddingLeft: '32px' }}
                                        ></input>
                                      </div>
                                    </div>
                                    {getRelativeDateLabel(ss.validFrom) && (
                                      <div style={{ paddingLeft: '32px', fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                                        {getRelativeDateLabel(ss.validFrom)}
                                      </div>
                                    )}
                                  </Col>
                                  <Col xs={12} md={6}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <span style={{ width: '24px', flexShrink: 0 }}></span>
                                      <div style={{ position: 'relative', flex: 1 }}>
                                        <FaCalendarCheck style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: '14px', pointerEvents: 'none' }} />
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={ss.expiryDate ? ss.expiryDate : ""}
                                          onChange={(e) =>
                                            handleSubTextChange(e, sub.sn, ss.sn, "expiryDate")
                                          }
                                          placeholder="Valid to (DMY HMS)"
                                          style={{ paddingLeft: '32px' }}
                                        ></input>
                                      </div>
                                    </div>
                                    {getRelativeDateLabel(ss.expiryDate) && (
                                      <div style={{ paddingLeft: '32px', fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                                        {getRelativeDateLabel(ss.expiryDate)}
                                      </div>
                                    )}
                                  </Col>
                                  <Col xs={12}>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                      <span style={{ width: '24px', flexShrink: 0 }}></span>
                                      <textarea
                                        className="form-control subsub-description-textarea"
                                        value={ss.description ? ss.description : ""}
                                        onChange={(e) =>
                                          handleSubTextChange(e, sub.sn, ss.sn, "description")
                                        }
                                        placeholder="Description (Markdown)"
                                        rows={4}
                                      ></textarea>
                                    </div>
                                  </Col>
                                </div>
                              )}
                            </Row>
                            {validityStatus.label && (
                              <div className="SubSubTaskTiming" style={{ color: validityStatus.labelColor }}>
                                {validityStatus.label}
                              </div>
                            )}
                            <div className="SubSubButtonControls">
                              <div className="SubSubButtonCluster">
                                <Button
                                  variant="danger"
                                  onClick={() => {
                                    deleteSubSub(sub.sn, ss.sn);
                                  }}
                                >
                                  <AiFillDelete></AiFillDelete>
                                </Button>
                                <Button
                                  variant="success"
                                  onClick={() => {
                                    addToDoneList(sub.sn, ss.sn, ss.name, ss.finish);
                                  }}
                                >
                                  <AiFillCheckCircle></AiFillCheckCircle>
                                </Button>
                                <Button
                                  variant="primary"
                                  onClick={() => { starSubSub(sub.sn, ss.sn) }}
                                ><AiFillStar></AiFillStar></Button>
                                <Button
                                  variant="primary"
                                  onClick={() => {
                                    promoteSubSub(sub.sname, ss.name)
                                  }}
                                >
                                  <FaArrowUp></FaArrowUp>
                                </Button>
                                <Button
                                  variant="primary"
                                  onClick={() => {
                                    demoteSubSub(sub.sname, ss.name)
                                  }}
                                >
                                  <FaArrowDown></FaArrowDown>
                                </Button>
                                <Button
                                  variant="primary"
                                  onClick={() => {
                                    promoteSubSubToTop(sub.sname, ss.name)
                                  }}
                                >
                                  !
                                </Button>
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="success"
                                    id={`subsub-recall-${sub.sn}-${ss.sn}`}
                                  >
                                    <FaClock></FaClock>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu align="end">
                                    {RECALL_OPTIONS.map((option) => (
                                      <Dropdown.Item
                                        key={`${ss.sn}-${option.value}`}
                                        onClick={() => {
                                          addToDoneListWithRecall(
                                            sub.sn,
                                            ss.sn,
                                            ss.name,
                                            ss.finish,
                                            option.value
                                          )
                                        }}
                                      >
                                        {option.label}
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="subtask-actions">
                      <Button
                        variant="success"
                        onClick={() => {
                          addSubSub(sub.sn);
                        }}
                      >
                        <IoAdd></IoAdd>
                      </Button>
                      {(enableDelete || true) && (
                        <Button
                          variant="danger"
                          onClick={() => {
                            deleteSub(sub.sn);
                          }}
                        >
                          <AiFillDelete></AiFillDelete>
                        </Button>
                      )}
                      <Button
                        variant="success"
                        onClick={() => {
                          addToDoneListForSubs(sub.sn);
                        }}
                      >
                        <AiFillCheckCircle></AiFillCheckCircle>
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => {
                          promoteSub(sub.sname)
                        }}
                      >
                        <FaArrowUp></FaArrowUp>
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => {
                          demoteSub(sub.sname)
                        }}
                      >
                        <FaArrowDown></FaArrowDown>
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => {
                          promoteSubToTop(sub.sname)
                        }}
                      >
                        <FaArrowUp></FaArrowUp>
                      </Button>
                    </div>

                  </div>
                </Col>
              );
              })}
            </Row>
            <div className="BottomButtons">
              <Button
                variant="success"
                onClick={() => {
                  addSub();
                }}
              >
                <IoAdd></IoAdd> ADD
              </Button>
              <Button variant="primary" onClick={() => { makeOriginal() }}>MAKE ORIGINAL</Button>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default Edit;
